import ProImage from '@assets/cc_pro.svg';
import { ContactCenterLogo } from '@components/ContactCenterLogo';
import { signInLocators } from '@locators/signin';
import { BodyText, StackItem } from '@servicetitan/design-system';
import { WelcomeContainer } from '../../SigninPage.styled';
import strings from './strings';

const PaywallComponent = () => {
  return (
    <WelcomeContainer direction='column' spacing='3'>
      <StackItem>
        <ContactCenterLogo />
      </StackItem>
      <StackItem>
        <div>
          <ProImage width={125} height={80} />
        </div>
      </StackItem>
      <StackItem>
        <BodyText bold>{strings.labels.header}</BodyText>
        <BodyText id={signInLocators.paywallParaElement} className='m-t-half'>
          {strings.labels.body}
        </BodyText>
      </StackItem>
    </WelcomeContainer>
  );
};

export default PaywallComponent;
